import PremiumToolNotification from "./components/PremiumToolNotification/PremiumToolNotification";
import { ProvideConfirmDialog } from "./components/ConfirmDialog/ProvideConfirmDialog";
import Djurplatser from "./tools/Djurplatser/Djurplatser";
import Grovfodret from "./tools/Grovfodret/Grovfodret";
import PlatserRekryteringsdjurMjolkproduktion from "./tools/PlatserRekryteringsdjurMjolkproduktion/PlatserRekryteringsdjurMjolkproduktion";
import ViLA from "./tools/ViLA/vila";
import { formatClassNames } from "./helpers/util";

export default function App() {
  let tool;
  if (window.wpObject != null && window.wpObject.cok_tool_id != null) {
    switch (window.wpObject.domElementId) {
      case "cok-djurplatser":
        tool = <Djurplatser />;
        break;
      case "cok-produktionskostnad_grovfoder":
        tool = <Grovfodret />;
        break;
      case "cok-rekryteringsdjur-mjolkproduktion-1":
        tool = <PlatserRekryteringsdjurMjolkproduktion />;
        break;
      case "cok-vila":
        tool = <ViLA />
        break;
      default:
        break;
    }
  }

  return tool != null ? (
    <PremiumToolNotification>
      <ProvideConfirmDialog>
        <div className={formatClassNames({ premiumPrint: window.wpObject?.print_results_enabled })}>
          {tool}
        </div>
      </ProvideConfirmDialog>
    </PremiumToolNotification>
  ) : (
    <div className="tools-config-error">Felkonfigurerad kortkod</div>
  );
}
